import { axisClasses } from '@mui/x-charts';
import {
  axisColorMap,
  darkGray,
  lightGray,
} from '../../../../../../../../theme/color-constants';
import { benchmarkColor, chartColorsHex } from '../../../../../../theme';

export const CHART_TITLE_HEIGHT = '24px';
export const CHART_CONTENT_HEIGHT = `calc(100% - ${CHART_TITLE_HEIGHT})`;

export const chartStyles = () => ({
  [`.${axisClasses.root}`]: {
    [`.${axisClasses.tick}, .${axisClasses.line}`]: {
      stroke: lightGray,
      strokeWidth: 1,
    },
  },
  [`.${axisClasses.directionY}`]: {
    [`.${axisClasses.tickLabel}`]: {
      fill: axisColorMap['left'],
    },
  },
  [`.${axisClasses.directionY}.${axisClasses.right}`]: {
    [`.${axisClasses.tickLabel}`]: {
      fill: axisColorMap['right'],
    },
  },
  [`.${axisClasses.directionX}`]: {
    [`.${axisClasses.tickLabel}`]: {
      fill: darkGray,
    },
  },
});

export interface ChartColorWheel {
  baseColor: string;
  benchmarkColor: string;
}

export const getChartColorWheel = (chartColors: string[]) => {
  const chartColorsToBenchmarkColorMap = {
    [chartColors[0]]: benchmarkColor,
  };
  return chartColors.map((color) => ({
    baseColor: color,
    benchmarkColor: chartColorsToBenchmarkColorMap[color] ?? color,
  }));
};

export const defaultChartColors: string[] = chartColorsHex;
